module.exports = __webpack_public_path__ + "img/icon2.123b12fd.png";